module.exports = __webpack_public_path__ + "static/media/Google_G_Logo.3ec228d3.svg";